module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/category-components/subcategory/subcategory-list/subcategory-list.component.css
// module id = ./src/app/category-components/subcategory/subcategory-list/subcategory-list.component.css
// module chunks = main